{
  "name": "grokio-app",
  "version": "6.1.27",
  "type": "module",
  "main": "expo-router/entry",
  "scripts": {
    "android": "DARK_MODE=media expo start --android",
    "ios": "DARK_MODE=media expo start --ios",
    "start": "expo start",
    "prebuild": "expo prebuild",
    "prebuild-web": "node scripts/prebuild-web.js",
    "lint": "eslint \"**/*.{js,jsx,ts,tsx}\" && prettier -c \"**/*.{js,jsx,ts,tsx,json}\"",
    "format": "eslint \"**/*.{js,jsx,ts,tsx}\" --fix && prettier \"**/*.{js,jsx,ts,tsx,json}\" --write",
    "web": "DARK_MODE=media expo start --web",
    "postinstall": "patch-package",
    "build-treeshaking-local": "npm run prebuild && NODE_ENV=production EXPO_UNSTABLE_METRO_OPTIMIZE_GRAPH=1 EXPO_UNSTABLE_TREE_SHAKING=1 npx expo export --platform web",
    "build-treeshaking": "NODE_ENV=production EXPO_UNSTABLE_METRO_OPTIMIZE_GRAPH=1 EXPO_UNSTABLE_TREE_SHAKING=1 npx expo export --platform web --source-maps",
    "build-local": "NODE_ENV=production npx expo export --platform web",
    "build": "npm run prebuild-web && EXPO_PUBLIC_WEB_BUILD=$(node -p \"require('./public/version.json').build\") NODE_ENV=production npx expo export --platform web --source-maps --clear",
    "upload-sourcemaps": "SENTRY_RELEASE=$(node -p \"require('./package.json').version\")-web node node_modules/@sentry/react-native/scripts/expo-upload-sourcemaps.js dist"
  },
  "dependencies": {
    "@expo/html-elements": "~57.0.0",
    "@expo/vector-icons": "^15.0.3",
    "@gluestack-ui/core": "^3.0.25",
    "@gluestack-ui/utils": "^3.0.21",
    "@gorhom/bottom-sheet": "^5.2.14",
    "@hookform/resolvers": "^4.1.3",
    "@hugeicons-pro/core-solid-rounded": "^4.2.1",
    "@hugeicons-pro/core-stroke-rounded": "^4.2.1",
    "@hugeicons/react-native": "1.0.15",
    "@legendapp/motion": "^2.4.0",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-clipboard/clipboard": "^1.16.3",
    "@sentry/react-native": "^8.17.2",
    "@shopify/flash-list": "^2.3.3",
    "@tanstack/react-query": "^5.100.9",
    "ajv": "^8.17.1",
    "ajv-keywords": "^5.1.0",
    "android-bridge": "file:./modules/android-bridge",
    "axios": "^1.16.0",
    "dayjs": "^1.11.20",
    "entities": "^6.0.0",
    "expo": "~57.0.8",
    "expo-application": "~57.0.2",
    "expo-asset": "~57.0.2",
    "expo-blur": "~57.0.2",
    "expo-build-properties": "~57.0.7",
    "expo-constants": "~57.0.2",
    "expo-crypto": "~57.0.1",
    "expo-dev-client": "~57.0.8",
    "expo-device": "~57.0.1",
    "expo-file-system": "~57.0.0",
    "expo-font": "~57.0.0",
    "expo-iap": "^3.4.13",
    "expo-image": "~57.0.1",
    "expo-image-manipulator": "~57.0.6",
    "expo-image-picker": "~57.0.6",
    "expo-linking": "~57.0.4",
    "expo-localization": "~57.0.1",
    "expo-location": "~57.0.6",
    "expo-media-library": "~57.0.3",
    "expo-network": "~57.0.1",
    "expo-notifications": "~57.0.7",
    "expo-quick-actions": "^6.0.2",
    "expo-router": "~57.0.8",
    "expo-screen-orientation": "~57.0.1",
    "expo-secure-store": "~57.0.1",
    "expo-splash-screen": "~57.0.5",
    "expo-system-ui": "~57.0.1",
    "expo-web-browser": "~57.0.2",
    "i18next": "^25.8.18",
    "jquery-deferred": "^0.3.1",
    "jquery-param": "^1.2.4",
    "nativewind": "^4.2.5",
    "react": "19.2.3",
    "react-dom": "19.2.3",
    "react-hook-form": "^7.54.2",
    "react-i18next": "^15.5.3",
    "react-native": "0.86.0",
    "react-native-css-interop": "^0.2.5",
    "react-native-edge-to-edge": "1.8.1",
    "react-native-gesture-handler": "~2.32.0",
    "react-native-keyboard-controller": "^1.22.0",
    "react-native-reanimated": "4.5.0",
    "react-native-safe-area-context": "~5.7.0",
    "react-native-screens": "~4.26.0",
    "react-native-svg": "15.15.4",
    "react-native-web": "^0.21.0",
    "react-native-webview": "13.16.1",
    "react-native-worklets": "0.10.2",
    "zod": "^3.25.76"
  },
  "devDependencies": {
    "@babel/core": "^7.20.0",
    "@expo/config": "~57.0.1",
    "@sentry/cli": "^3.4.1",
    "@types/react": "~19.2.10",
    "@typescript-eslint/eslint-plugin": "^7.7.0",
    "@typescript-eslint/parser": "^7.7.0",
    "babel-plugin-transform-imports": "^2.0.0",
    "babel-plugin-transform-remove-console": "^6.9.4",
    "eslint": "^8.57.0",
    "eslint-config-universe": "^12.0.1",
    "expo-atlas": "^0.4.0",
    "jscodeshift": "^0.15.2",
    "patch-package": "^8.0.1",
    "prettier": "^3.2.5",
    "prettier-plugin-tailwindcss": "^0.5.11",
    "tailwindcss": "^3.4.15",
    "typescript": "~6.0.3"
  },
  "overrides": {
    "@react-types/dialog": "3.5.24"
  },
  "eslintConfig": {
    "extends": "universe/native",
    "root": true
  },
  "expo": {
    "install": {
      "exclude": [
        "@shopify/flash-list",
        "@sentry/react-native",
        "react-native-keyboard-controller",
        "react-native-worklets"
      ]
    },
    "autolinking": {
      "apple": {
        "buildFromSource": [
          "RNWorklets",
          "RNReanimated",
          "ExpoModulesWorkletsAdapter"
        ]
      }
    }
  },
  "private": true
}
